import { Stack, Step, StepLabel, Stepper } from '@mui/material';
import { FormikProps } from 'formik';
import AddProductsCompleted from '../AddProductsCompleted';
import CreateProductList from './CreateProductList';
import { AddFromListFormValues } from './AddProductsFromList';

const ListSteps = (props: FormikProps<AddFromListFormValues>) => {
  const renderStep = (step: number) => {
    switch (step) {
      case 0:
        return <CreateProductList {...props} />;
      case 1:
        return <AddProductsCompleted {...props} />;
    }
  };

  return (
    <Stack>
      <Stepper activeStep={props.values.activeStep} sx={{ mb: 4 }}>
        <Step>
          <StepLabel>Create Product List</StepLabel>
        </Step>
        <Step>
          <StepLabel>Complete</StepLabel>
        </Step>
      </Stepper>
      {renderStep(props.values.activeStep)}
    </Stack>
  );
};

export default ListSteps;
